module.exports = __webpack_public_path__ + "3edc7c93475a36406c5886e90bab23cd.png";